// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"6b5ac0c9","6751":"100065f3","8618":"6b5ac0c9"}[chunkId] + ".chunk.css";
};